<!-- 成绩设置 -->
<template>
    <div>
    <div class="title flex-row-center">
        <div>
            <span>第{{round}}轮 成绩设置</span><span class="red mg-l-10">{{errorMsg}}</span>
        </div>        
        <el-button style="font-size: 16px;" type="danger" @click="scoreConfirm" :disabled="disabled">本轮成绩确认</el-button>
    </div>  
    <el-row  :span="6" class="mg-b-10" >
        修改第  {{newRound}} 轮成绩
        <el-select v-model="newRound" placeholder="请选择轮数" @change="newUpDownRound" >
            <el-option 
                v-for="item in roundList"  
                :value="item.value"  
                :label="item.label" 
                :key="item.label">
            </el-option>
        </el-select>       
    </el-row>
    <div class="score-table custom-table2">
        <el-table :data="newTableData"  :row-class-name="tableRowClassName" 
        class="custom-table" style="width: 100%" border>
            <el-table-column prop="deskNo" label="桌号" align="center" width="80"/>
            <el-table-column prop="usernameWE" label="东西" align="center"/>
            <el-table-column prop="scoreWE" label="成绩" align="center" width="90"/>       
            <el-table-column prop="usernameSN" label="南北" align="center" />     
            <el-table-column prop="scoreSN" label="成绩" align="center" width="90"/>  
            <el-table-column prop="number" label="操作" width="240" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleUpdateScore(scope.row)" type="text" size="medium">
                        {{ disabled?'修改成绩':'记录成绩' }}</el-button>
                    <el-button @click="handleDeleteScore(scope.row)" type="text" size="medium" v-if="!disabled">清除成绩</el-button>
                </template>
            </el-table-column>  
        </el-table>
    </div>  
<el-dialog
  title="确定弃权吗？请选择弃权方位"
  :visible.sync="showSeatScore"
  width="30%"
  :before-close="handleClose">
    <div class="seat-wrap">
        <el-checkbox-group v-model="checkList" @change="changeSingle" class="mg-lr-20">
            <el-checkbox label="东"></el-checkbox>
            <el-checkbox label="南"></el-checkbox>
            <el-checkbox label="西"></el-checkbox>
            <el-checkbox label="北"></el-checkbox>
        </el-checkbox-group>        
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="confirmGameCancel" type="primary">确认弃权</el-button>
        <el-button @click="handleCancel">取消</el-button>
    </span>       
</el-dialog>
<!-- 裁判清除成绩 -->
<el-dialog
  title="确定清除成绩吗?"
  :visible.sync="showRemoveScore"
  width="30%"
  :before-close="handleClose">
    <div class="seat-wrap">
        <el-radio-group v-model="gamesIdValue" class="mg-lr-20">
            <el-radio :label="0">清除所有把成绩</el-radio>
            <el-radio :label="111">清除当前把成绩</el-radio>
        </el-radio-group>
        <div></div>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="confirmRemoveScore" type="primary">确认</el-button>
        <el-button @click="handleCancel">取消</el-button>
    </span>       
</el-dialog>
<!-- 设置每局或全部分数 -->
<el-dialog
  title="设置每局或全部分数"
  :visible.sync="showPoker"
  width="50%"
  :before-close="handleClose">
    <div class="score-dialog" v-if="showPoker">
      <div class="dialog-title">设置第{{deskNo}}桌分数</div>
      
      <!-- 模式选择 -->
      <div class="mode-selection">
        <span class="mode-label">设置方式：</span>
        <el-radio-group v-model="settingMode" @change="handleSelectSetCard">
          <el-radio :label="1">每把设置</el-radio>
          <el-radio :label="2">全部设置</el-radio>
        </el-radio-group>
      </div>
      
      <!-- 牌选择 -->
      <div class="card-selection">
        <div class="card-selection-label">先选择牌号</div>
        <div class="cards-container" v-if="settingMode===1">
          <div 
            v-for="item in newCards" 
            :key="item.value"
            class="card-item"
            :class="
               item.gamesNum !=='' && item.value === maxScoreWE ?'isLastGames':item.gamesNum !==''?'selectedOne':selectedCards.includes(item.value)?'newSelected': ''"
            @click="selectCard(item.value)"
          >
            <div>{{ item.label }}</div>
            <div>{{ item.gamesNum }}</div>            
          </div>                  
        </div>
        <div class="cards-container" v-if="settingMode===2">
          <div 
            v-for="card in cards" 
            :key="card.value"
            class="card-item"
            :class="{'selected': selectedCards.includes(card.value),
            'disabled': settingMode === 1 && selectedCards.length > 0 && !selectedCards.includes(card.value)}"
            @click="selectCard(card.value)"
          >
            {{ card.label }}
          </div>          
        </div>
      </div>
      
      <!-- 分数选择 -->
      <div class="score-selection">
        <!-- 东西分数 -->
        <div class="score-section">
          <div class="score-title">东西 请选择升级数</div>
          <div class="score-options">
            <el-radio-group v-model="scorePokerWE" @change="handleEastWestChange">
              <el-radio :label="1">1</el-radio>
              <el-radio :label="2">2</el-radio>
              <el-radio :label="3">3</el-radio>
            </el-radio-group>
          </div>
        </div>
        
        <!-- 南北分数 -->
        <div class="score-section">
          <div class="score-title">南北 请选择升级数</div>
          <div class="score-options">
            <el-radio-group v-model="scorePokerSN" @change="handleSouthNorthChange">
              <el-radio :label="1">1</el-radio>
              <el-radio :label="2">2</el-radio>
              <el-radio :label="3">3</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
      
      <!-- 操作按钮 -->
      <div class="action-buttons">
        <el-button class="mg-t-20" type="danger"  @click="updateScore" v-if="disabled">确认修改</el-button>
        <el-button type="primary" @click="confirmScore">成绩确认</el-button>
        <el-button @click="cancel">关闭</el-button>
      </div>
    </div>
    </el-dialog>
</div>
 </template>
 
 <script>
import { mapState } from 'vuex'

 export default {
     props:{
        pubId: {
             type: String,
             default: ''
         },
        pubType: {
            type: String,
            default: ''
        }
     },
     data() {
         return {
            activeA: 0,
            activeB: 0,
            dataList: [],
            tableData: [],
            ready: false,
            deskNo: 1,
            playersId: 1,
            thingPoker: '',
            northSouthPoker: '',
            showPoker: false,
            gamesId: 0,
            tableDataSign: [],
            tableDataDouble: [],
            newTableData: [],
            porkWE: false,
            porkSN:false,
            errorMsg: '',
            checkList: [],
            eastScore: 2,
            southScore: 2,
            westScore: 2,
            northScore: 2,  
            showSeatScore: false,
            roundList:[
                {label:1,value:1},
                {label:2,value:2},
                {label:3,value:3},
                {label:4,value:4},
            ],
            newRound: null,
            disabled: false,
            showRemoveScore: false,
            gamesIdValue: 0,
            removeDeskNo: 0,
            pokerList: [],
            // 设置模式：1-每局设置，2-全部设置
            settingMode: 1,
            // 所有牌
            cards: [],
            newCards: [],
            // 选中的牌
            selectedCards: [],
            // 东西分数
            scorePokerSN: 0,
            // 南北分数
            scorePokerWE: 0,
            maxScoreWE: '',
         }
     },
     created() {
        
     },
     mounted() {        
        // this.getPokerQuery()
        // document.addEventListener('click',this.handleClickOutside)
     },
     computed:{
        ...mapState(['round'])
     },
     methods: {
        tableRowClassName({row, rowIndex}){
            // 一桌一种颜色
            if(row.deskNo % 2){
                return 'white-row'
            }else{
                return  'green-row'
            }
        },
         // 赛事成绩查询
         initData(){
             let params = {
                opcode: this.$code.ScoreQuery,
                i_serial_mark: this.pubId,
                i_round: this.round,
                i_games_id: 111,
                i_desk_no: 0,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.disabled = false
                    this.newRound = null
                    if(result.length === 0){
                        this.errorMsg = '请到编排界面，点击编排按钮！'
                        this.newTableData = []
                    }else{
                        this.errorMsg = ''
                       
                        let arr =  result.map(item=>{
                            return {
                                gamesId: item['局数'],
                                deskNo: item['桌号'],
                                seat: item['座位'],
                                score: item['成绩'],
                                level: item['升级'],
                                username: item['选手名称'],
                                round: item['轮数'],
                                partner: item['搭档名称'],
                                playersId: item['选手编号'],
                            }
                        })
                        let newArr  = this.selectDeskNo(arr)
                        this.newTableData = newArr
                        // console.log('成绩',newArr)                        
                    }  
                    this.getPoker()                  
                }else{
                    this.errorMsg = res.Message
                    this.newTableData = []
                }
             })       
         },  
         selectDeskNo(arr){
             let result = []
             arr.forEach(item => {
                 if(!result.some(i => i.deskNo === item.deskNo )){
                        let newArr = arr.filter(user => user.deskNo === item.deskNo)                        
                        let scoreWE = ''
                        let scoreSN= ''
                        let usernameWE = ''
                        let usernameSN = ''                      
                        usernameWE = (newArr.filter(i =>  i.seat.includes('东')))[0].username +'/'+ (newArr.filter(i =>  i.seat.includes('东')))[0].partner
                        usernameSN = (newArr.filter(i =>  i.seat.includes('北')))[0].username +'/'+ (newArr.filter(i =>  i.seat.includes('北')))[0].partner
                        scoreWE = (newArr.filter(i =>  i.seat.includes('东')))[0].level
                        scoreSN = (newArr.filter(i =>  i.seat.includes('北')))[0].level
                                              
                        result.push({
                            deskNo: item.deskNo,
                            scoreWE: scoreWE,
                            scoreSN: scoreSN,
                            usernameWE: usernameWE,
                            usernameSN: usernameSN,
                            gamesId: item.gamesId,
                        })
                 }
             });
             return result
         },    
          // 查询某一桌的成绩
          getDeskNoScore(){
             let params = {
                opcode: this.$code.ScoreQueryNew,
                i_serial_mark: this.pubId,
                i_round: this.round,
                // i_games_id: 0,
                i_desk_no: this.deskNo,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable
                  
                    let arr =  result.map(item=>{
                      let score = item['成绩'] ? JSON.parse(item['成绩']): ''
                        return {
                          teamTypeWE: item['东西'],
                          teamTypeSN: item['南北'],
                          totalScoreWE: item['东西总升级'] || 0,
                          totalScoreSN: item['南北总升级'] || 0,
                          deskNo: item['桌号'],  
                          usernameWE: item['东西选手'],
                          usernameSN:item['南北选手'],      
                          score: score,
                        }
                    })
                    // console.log(arr)  
                    let gamesArr = arr.map(item=>{
                      let score = item.score ? item.score : ''
                      return{
                          ...score,                        
                      }
                    })
                    
                    let WE = gamesArr[0]
                    let totalScore = [];
                    for (var key in WE) {
                      if (WE.hasOwnProperty(key)) {
                          var value = WE[key];
                          var newObj = {
                              key: key,
                              value: value
                          };                        
                          totalScore.push(newObj);
                      }
                    }
                    if(totalScore.length > 0){
                      this.maxScoreWE = totalScore[totalScore.length-1].value
                    }
                    console.log(gamesArr,totalScore.length)
                    if(arr[0].score === ''){
                      // console.log('A')
                        this.gamesIdValue = 1
                    }else{
                      //  console.log('B')
                        this.gamesIdValue = totalScore.length+1
                    }
                    let scoreObjWE = JSON.parse(JSON.stringify(this.cards))
                     
                    // 遍历数组2，并基于array1中的匹配来更新gamesNum
                    scoreObjWE.forEach(function(obj2) {
                        // 在array1中查找与obj2.value匹配的对象
                        var matchingObj1 = totalScore.find(function(obj1) {
                            return obj1.value === obj2.value;
                        });                    
                        // 如果找到匹配的对象，则更新gamesNum
                        if (matchingObj1) {
                            obj2.gamesNum = matchingObj1.key;                    
                        }else{
                            obj2.gamesNum = ''
                        }                   
                    });
                    console.log(this.gamesIdValue,scoreObjWE) 
                    this.newCards = scoreObjWE
                  
                    // let selectedScore = [...new Set(arr.map(item => item.score))]
                    // if(selectedScore.length >0){
                    //   this.selectedCards = selectedScore
                    // }else{
                    //   this.selectedCards = []
                    // }
                    // console.log(this.gamesIdValue,this.selectedCards)
                 }
             })       
            },         
        //  本轮赛事完成
        completed(){
             let params = {
                opcode: this.$code.PubComplete,
                i_serial_mark: this.pubId,
                i_round: this.round
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                     let result = res.Data.DataTable
                                
                 }
             })       
         },     
        //  赛事排名查看
        getRankQuery(){
            let params = {
                opcode: this.$code.RankQuery,
                i_serial_mark: this.pubId,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                     let result = res.Data.DataTable
                     this.tableData = result.map(item=>{                    
                        return{
                            id: item['选手编号'],
                            rank: item['名次'],
                            score: item['积分'],
                            levelNum: item['升级数'],
                            partnerScore: item['搭档总分'],
                            totalRank: item['级差总分'],
                            partnerRank: item['搭档总级差分'],
                            totalScore: item['累计分'],
                            winNum: item['胜轮次'],                            
                        }
                    })           
                 }
             })  
        },
        // 级牌
        getPoker(){
            let params = {
                opcode: this.$code.RoundCardsQuery,
                i_serial_mark: this.pubId,
                i_round: this.round,
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {   
                    let result = res.Data.DataTable  
                    if(result.length > 0 ){
                        let list = result[0]['本轮级牌']
                       
                        let cardArray = list.split('-')
                        let pokerList = this.generateCardArray(cardArray[0], cardArray[1])
                       
                        this.cards = pokerList.map(value => ({
                          value,
                          label: value,
                          gamesNum: '',
                        })); 
                        // console.log('数组牌',this.cards)
                    }                        
                }
            }).catch(err=>{}) 
        },   
        generateCardArray(start, end){
            const cardValues = {  
                '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, '10': 10,  
                'J': 11, 'Q': 12, 'K': 13  ,'A': 14
            };  
            
            const valueToCard = {  
                11: 'J', 12: 'Q', 13: 'K' , 14: 'A' 
            };  
            
            const startValue = cardValues[start];  
            const endValue = cardValues[end];  
            
            if (startValue === undefined || endValue === undefined) {  
                throw new Error('Invalid card face');  
            }  
            
            const values = [];  
            for (let i = startValue; i <= endValue; i++) {  
                values.push(i);  
            }  
            
            const cards = values.map(value => {  
                if (value <= 10) {  
                    return value.toString();  
                } else {  
                    return valueToCard[value];  
                }  
            });  
            
            return cards;  
        },
        selectPoker(value,index){
            // console.log(value)
            this.activeA = value
            this.thingPoker = value   
            // this.porkWE = false     
            this.poker = value 
            this.scorePokerSN = 0
            this.scorePokerWE = 0
        },
        // 管理员设置分数
        handleUpdateScore(row){
            // console.log('记录成绩',row)
            this.checkList =  []
            this.deskNo = row.deskNo 
            this.showPoker = true
            this.gamesId = row.gamesId
            // console.log(this.gamesIdValue)
            this.scorePokerSN = 0
            this.scorePokerWE = 0
            this.porker = ''
            this.selectedCards = []
            this.settingMode = 1
            this.getDeskNoScore()
        },
        // 赛事成绩详情
        scoreDetail(){
            let params = {
                opcode: this.$code.RankScoreDetail,
                i_serial_mark: this.pubId
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable
                                       
                }
            })
        },
         // 本局赛事成绩提交 管理员提交
         scoreSubmit(){
            let games = ''
            let poker = ''
            if(this.settingMode === 2){
                games = 0
                poker = ''
            }else{
                games = this.gamesIdValue
                poker = this.poker
            }            
            let params = {
                opcode: this.$code.TeamScoreSub,
                i_serial_mark: this.pubId,
                i_games_id: games,
                poker: poker,
                i_round: this.round,
                i_desk_no: this.deskNo,
                thing_poker: this.scorePokerWE,
                northsouth_poker: this.scorePokerSN,
             }
            //  console.log('提交成绩',params)
             this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    // this.$message.success(res.Message)
                    if(this.settingMode === 1){
                      this.getDeskNoScore()
                    }else{
                      this.initData()    
                      this.showPoker = false
                    }
                }else{
                    this.$message.error(res.Message)  
                }
             })       
         }, 
        // 本轮赛事成绩确认
        scoreConfirm(){
            this.$confirm('确认每一桌成绩都设置完成，再进行成绩完成确认！','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                
            }).then(()=>{
                let params = {
                    opcode: this.$code.PubComplete,
                    i_serial_mark: this.pubId,
                    i_round: this.round,
                }
                // console.log(params)
                this.$api.requestAPI(params).then(res=>{
                    if(res.IsSuccess){
                        this.$message.success('请到团队排名中查看')      
                        this.saveRank()
                    }else{
                        this.$message.error(res.Message)
                    }
                })
            }).catch((err)=>{
                console.log(err)
            })             
        },
        // 管理员删除选手每一轮的成绩
        handleDeleteScore(row){
            this.showRemoveScore = true
            this.removeDeskNo = row.deskNo
            // this.$confirm(`确认清除第${row.deskNo}桌的成绩吗?`,'提示',{
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
                
            // }).then(()=>{
            //     let params = {
            //         opcode: this.$code.ScoreDeleteRound,
            //         i_serial_mark: this.pubId,
            //         i_round: this.round,
            //         i_games_id: 0,
            //         i_desk_no: row.deskNo
            //     }
            //     // console.log(params)
            //     this.$api.requestAPI(params).then(res=>{
            //         if(res.IsSuccess){
            //             this.$message.success('删除成功')      
            //             this.initData()
            //         }else{
            //             this.$message.error(res.Message)
            //         }
            //     })
            // }).catch((err)=>{
            //     console.log(err)
            // }) 
        },
        confirmRemoveScore(){
            let params = {
                opcode: this.$code.ScoreDeleteRound,
                i_serial_mark: this.pubId,
                i_round: this.round,
                i_games_id: this.gamesIdValue,
                i_desk_no: this.removeDeskNo
            }
            // console.log(params)
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('删除成功')      
                    this.initData()
                    this.showRemoveScore = false
                    this.gamesIdValue = 0
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        // 赛事排名保存
        saveRank(){
            let params = {
                opcode: this.$code.SaveRank,
                i_serial_mark: this.pubId,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    // this.$message.success('保存成功')
                    // this.errorMessage = ''
                 }else{
                    // this.errorMessage = res.Message
                    // this.$message.error(res.Message)
                 }
             })  
        },  
        changeSingle(value){
            if(value.length > 0){
                this.eastScore =  value.includes('东')?'弃':'6'
                this.southScore =  value.includes('南')?'弃':'6'
                this.westScore =  value.includes('西')?'弃':'6'
                this.northScore =  value.includes('北')?'弃':'6'
            }
        },
        confirmGameCancel(){
            let round = this.disabled ? this.newRound : this.round
            let params = {
                opcode: this.$code.SingelGameOver,
                i_serial_mark: this.pubId,
                i_round: round,
                i_desk_no: this.deskNo,
                i_players_number: 0,
                east_poker: this.eastScore,
                south_poker: this.southScore,
                west_poker: this.westScore,
                north_poker: this.northScore,
            }
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.showSeatScore = false;
                    this.checkList = []
                    this.showPoker = false
                    this.initData()
                }
            })
        },
        handleClickOutside(event){
            // console.log(event.target)          
            if (!event.target.closest('button')) {
                // 执行你想在点击按钮以外的地方时执行的操作
                console.log('点击了页面以外的区域');
                this.showPoker = false
                this.thingPoker = ''
                this.northSouthPoker = ''
            }
        },
        handleClose(){
            this.showPoker = false
            this.thingPoker = ''
            this.northSouthPoker = ''
            this.scorePokerWE = 0
            this.scorePokerSN = 0
            this.initData()
        },
        handleCancel(){
            this.showSeatScore = false;
            this.checkList = []
            this.showRemoveScore = false
        },
        getRoundQuery(){
            let params = {
                opcode: this.$code.ScoreQuery,
                i_serial_mark: this.pubId,
                i_round: this.newRound,
                i_games_id: 111,
                i_desk_no: 0,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    if(result.length === 0){
                        this.errorMsg = '请到编排界面，点击编排按钮！'
                        this.newTableData = []
                    }else{
                        this.errorMsg = ''
                        if(this.pubType === '1'){
                            let arr =  result.map(item=>{
                            return {
                                gamesId: item['局数'],
                                deskNo: item['桌号'],
                                seat: item['座位'],
                                score: item['成绩'],
                                username: item['选手名称'],
                                round: item['轮数'],
                                playersId: item['选手编号'],
                            }
                        })
                        let newArr  = this.selectDeskNo(arr)
                        this.newTableData = newArr
                        // console.log('单人',newArr)
                        }else{
                            let arr =  result.map(item=>{
                                return {
                                    gamesId: item['局数'],
                                    deskNo: item['桌号'],
                                    seat: item['座位'],
                                    score: item['成绩'],
                                    username: item['选手名称'],
                                    round: item['轮数'],
                                    partner: item['搭档名称'],
                                    playersId: item['选手编号'],
                                }
                            })
                            let newArr  = this.selectDeskNo(arr)
                            this.newTableData = newArr
                            // console.log('双人',newArr)
                        }
                    }                    
                }else{
                    this.errorMsg = res.Message
                    this.newTableData = []
                }
             })       
         },
        newUpDownRound(){             
            if(this.newRound > this.round){
                this.disabled = false
                this.$message.error("暂无这一轮成绩")
                this.newTableData = []
            }else{
                this.disabled = true                
                this.getRoundQuery()
            }
            if(this.newRound == this.round){
                this.disabled = false
            }
        },
        updateScore(){
            if(this.scorePokerWE === 0 || this.scorePokerSN === 0 ){
                this.$message.error('请先选择选手分数！')
                return false
            }
            let params = {
                opcode: this.$code.UpdateScore,
                i_serial_mark: this.pubId,
                i_round: this.newRound,
                i_desk_no: this.deskNo,
                thing_poker: this.scorePokerWE,
                northsouth_poker: this.scorePokerSN
            }
            this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {                    
                    this.$message.success("修改成功")
                    this.getRoundQuery()
                    this.showPoker = false
                 }else{
                    this.$message.error(res.Message)
                 }
            })
        },

        // 选择牌
        selectCard(cardValue) {
          if (this.settingMode === 1) {
            // 每局设置模式：只能选择一张牌
            this.selectedCards = [cardValue];
            this.poker = cardValue
            this.activeA = cardValue
          } else {
            // 全部设置模式：可以多选
            const index = this.selectedCards.indexOf(cardValue);
            this.poker = cardValue
            if (index > -1) {
              this.selectedCards.splice(index, 1);
            } else {
              this.selectedCards.push(cardValue);
            }            
          }
        },
        // 切换模式
        handleSelectSetCard(value){
            if(value===1){
                this.selectedCards = []
            }else{             
              this.selectedCards = this.cards.map(i=>i.value);
              console.log(this.selectedCards)
            }
        },
        // 东西分数变化
        handleEastWestChange(value) {
          if (value > 0) {
            this.scorePokerSN = 0;
          }
        },
        
        // 南北分数变化
        handleSouthNorthChange(value) {
          if (value > 0) {
            this.scorePokerWE = 0;
          }
        },        
        // 确认成绩
        confirmScore() {
          if (this.selectedCards.length === 0) {
            this.$message.warning('请至少选择一张牌');
            return;
          }
          
          if (this.scorePokerSN === 0 && this.scorePokerWE === 0) {
            this.$message.warning('请选择东西或南北的分数');
            return;
          }
          
          // 构建提交数据
          const data = {
            mode: this.settingMode === 1 ? 'perGame' : 'all',
            cards: this.selectedCards,
            scorePokerSN: this.scorePokerSN,
            scorePokerWE: this.scorePokerWE
          };
          
          console.log('提交的数据:', data);
          this.$message.success('成绩设置成功！');
          
          // 在实际应用中，这里可以发送API请求
          this.scoreSubmit()
        },        
        // 取消
        cancel() {
          // 在实际应用中，这里可以关闭弹框或返回上一页
          this.showPoker = false
          this.initData()
        }
     },
     destroyed() {
        document.removeEventListener('click', this.handleClickOutside);
     },
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
     font-size: 28px;
     margin-bottom: 10px;
 }
 .custom-table >>> .el-table__header-wrapper tr th{
    font-size: 20px;
    color: #000;
}
 .el-table >>> .green-row{
    background-color: #bbffbb
  }
  .el-table >>> .white-row{
    background-color: #f0f9eb;
  }
 table {
     width: 100%;
     border-collapse: collapse;
   }
   th, td {
     border: 1px solid #999;
     padding: 8px;
     text-align: left;
     font-size: 28px;
   }
   tr:nth-child(even) {
     background-color: lightblue;
   }
   thead th {
     background-color: #f2f2f2;
     font-size: 30px;
     text-align: center;
   }
   .table-label {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px;
     background-color: #f9f9f9;
     border: 1px solid #ddd;
   }
   .custom-table >>> .el-table__header-wrapper tr th{
    font-size: 18px;
    color: #333;
}
.card-number-q{  
    padding: 6px 10px;
    border-radius: 50%;
    color:#fff;
    cursor: pointer;
    margin-left: 14px;
    text-align: center;
    font-weight: bold;
    border: 1px solid #eee;
    background-color: red;
  }
  .card-number-q:hover{
    background-color: #f99f43;
  }
.card-number{    
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    color:#fff;
    cursor: pointer;
    margin-right: 4px;
    text-align: center;
    font-weight: bold;
    border: 1px solid #eee;
    background-color: #3bcdf1;
  }
  .card-number:hover{
    background-color: #f99f43;
  }
  .isSelected{
    background-color: #ffcc00;
  }
  .card-pok{
    display: flex;
    flex-wrap: wrap;
  }
  .confirm-btn{
    margin-top: 20px;
    text-align: right;
  }
  .mg-l-10{
    margin-left: 10px;
  }
  .seat-wrap{
    padding: 10px 30px;
    background-color: #fff;
  }
  .score-wrap{
    min-width: 400px;
    padding: 10px 30px;
    background-color: #fff;
    position: fixed;
    top: 30%;
    left: 45%;
    z-index: 2;
    border: 1px solid #e1e1e1;
    border-radius: 10px;
  }
  .mg-lr-20{
    margin: 0 20rpx;
  }
.custom-table2 .el-table__cell {
    padding: 0 !important;
}

// 设置分数样式
 .score-dialog {
      font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
      padding: 20px;
      background-color: #f5f7fa;
      border-radius: 4px;
      width: 90%;
      border: 1px solid #67c23a;

    }
    
    .dialog-title {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #303133;
    }
    
    .mode-selection {
      margin-bottom: 20px;
      text-align: center;
    }
    
    .mode-label {
      font-size: 14px;
      color: #606266;
      margin-right: 15px;
    }
    
    .card-selection {
      margin-bottom: 20px;
    }
    
    .card-selection-label {
      font-size: 14px;
      color: #606266;
      margin-bottom: 10px;
    }
    
    .cards-container {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 10px;
    }
    
    .card-item {
      width: 50px;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      cursor: pointer;
      font-weight: bold;
      transition: all 0.3s;
    }
    
    .card-item.selected {
      background-color: #67c23a;
      color: white;
      border-color: #67c23a;
    }
    
    .card-item.disabled {
      background-color: #f5f7fa;
      color: #c0c4cc;
      cursor: not-allowed;
    }
    .isLastGames{      
      background-color: #f75e00;
      color: white;
      border-color: #f75e00;
    }
    .selectedOne{
      background-color: green;
      color: white;
      border-color: green;
    }
    .newSelected{
      background-color: #67c23a;
      color: white;
      border-color: #67c23a;
    }
    .score-selection {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
    }
    
    .score-section {
      flex: 1;
      padding: 0 10px;
    }
    
    .score-title {
      font-size: 14px;
      color: #606266;
      margin-bottom: 10px;
      text-align: center;
    }
    
    .score-options {
      display: flex;
      justify-content: center;
      gap: 15px;
    }
    
    .action-buttons {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 20px;
    }
    
    .el-radio {
      margin-right: 15px;
    }
    
    .el-button {
      min-width: 100px;
    }
    
 </style>


// WEBPACK FOOTER //
// src/views/team/components/setScore.vue